import React, { FC, useEffect } from 'react'
import s from './Contacts.module.scss'
import { NavLink } from 'react-router-dom'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { useAppSelector } from '../../store/hooks'
import { YMaps, Map, Placemark, ZoomControl, FullscreenControl } from '@pbe/react-yandex-maps'
import { FaPhone, FaEnvelope, FaTelegram, FaWhatsapp,  FaMapMarkerAlt, FaFileAlt } from 'react-icons/fa'
import { ReactComponent as MaxIcon } from './../../assets/icons/maxIcon.svg';

import { Helmet } from 'react-helmet-async'
import Loader from '../../components/Loader/Loader'
import { scrollToTop } from '../../utils'

const Contacts: FC = () => {
    const { info, loading } = useAppSelector(state => state.info)
    
    useEffect(() => {
        scrollToTop()
    }, [])

    const mapCenter = [
        info?.contacts?.map_latitude,
        info?.contacts?.map_longitude
    ]

    return (
        <>
            <Helmet>
                <meta property="og:title" content="Контакты | Phoenix Programs" />
                <meta property="og:description" content="Свяжитесь с нами | Phoenix Programs - разработка программного обеспечения" />
                <meta name="twitter:title" content="Контакты | Phoenix Programs" />
                <meta name="twitter:description" content="Свяжитесь с нами | Phoenix Programs" />
                <link rel="canonical" href="https://phoenix-programs.com/contacts" />
                <title>Контакты | Phoenix Programs</title>
            </Helmet>
            {loading && <Loader />}
            <TopBanner title='Контакты' />
            <Breadcrumbs>
                <NavLink to={'/'}>Главная</NavLink>
                /
                <NavLink to={'/contacts'}>Контакты</NavLink>
            </Breadcrumbs>
            <section className={s.section}>
                <div className={`${s.container} container`}>
                    <h2 className='title'>НАШИ КОНТАКТЫ</h2>
                    <p className={s.subtitle}>Свяжитесь с нами любым удобным способом.</p>
                    
                    <div className={s.wrapper}>
                        <div className={s.contactInfo}>
                            <div className={s.contactItem}>
                                <div className={s.iconWrapper}>
                                    {React.createElement(FaPhone as any)}
                                </div>
                                <div className={s.content}>
                                    <h3>Телефон</h3>
                                    <a href={`tel:${info?.contacts?.phone}`}>{info?.contacts?.phone}</a>
                                </div>
                            </div>

                            <div className={s.contactItem}>
                                <div className={s.iconWrapper}>
                                    {React.createElement(FaEnvelope as any)}
                                </div>
                                <div className={s.content}>
                                    <h3>E-Mail</h3>
                                    <a href={`mailto:${info?.contacts?.email}`}>{info?.contacts?.email}</a>
                                </div>
                            </div>

                            <div className={s.contactItem}>
                                <div className={s.iconWrapper}>
                                    {React.createElement(FaMapMarkerAlt as any)}
                                </div>
                                <div className={s.content}>
                                    <h3>Адрес</h3>
                                    <p>{info?.contacts?.address}</p>
                                </div>
                            </div>

                            <div className={s.contactItem}>
                                <div className={s.iconWrapper}>
                                    {React.createElement(FaFileAlt as any)}
                                </div>
                                <div className={s.content}>
                                    <h3>Реквизиты</h3>
                                    <p>{info?.contacts?.inn}</p>
                                </div>
                            </div>

                            <div className={s.socialLinks}>
                                <h3>Мы в соцсетях:</h3>
                                <div className={s.social}>
                                    <a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.telegram}`}>
                                        {React.createElement(FaTelegram as any)}
                                    </a>
                                    <a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.whatsapp}`}>
                                        {React.createElement(FaWhatsapp as any)}
                                    </a>
                                    {info?.contacts?.vk && (
                                        <a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.vk}`}>
                                            {React.createElement(MaxIcon as any)}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={s.mapWrapper}>
                            <YMaps>
                                <Map
                                    className={s.map}
                                    defaultState={{ 
                                        center: mapCenter as [number, number], 
                                        zoom: 17 
                                    }}
                                >
                                    <Placemark geometry={mapCenter as [number, number]} />
                                    <ZoomControl options={{ position: { right: 10, top: 50 } }} />
                                    <FullscreenControl options={{ position: { right: 10, top: 110 } }} />
                                </Map>
                            </YMaps>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contacts

